<template>
  <div class="mb-3">
    <custom-callout :has-toggle="false">
      <div class="row">
        <div
          class="col-sm-5 col-xl-3 my-2 border-right d-flex flex-column justify-content-center align-items-start"
          style="padding: 0 40px;"
        >
          <span
            class="badge badge-pill mb-2 font-16"
            :class="[`badge-${sufixType}`]"
          >
            {{ name }}
          </span>
          <div class="color-secondary-6 font-14">Número de Aviso:</div>
          <div class="font-weight-normal color-black font-16">
            <b>{{ code }}</b>
          </div>
        </div>
        <div class="col-sm-7 col-xl-6" style="padding: 0 40px;">
          <div class="color-secondary-6 font-14">
            Nombre del Aviso:
          </div>
          <div class="font-weight-normal color-black font-16">
            {{ description }}
          </div>
          <div class="row mt-3">
            <div class="col-md-6 col-xl-3">
              <div class="color-secondary-6 font-14">
                Fecha de Publicación:
              </div>
              <div class="font-weight-normal color-black font-16">
                {{ publishDate | date }}
              </div>
            </div>
            <div class="col-md-6 col-xl-3">
              <div class="color-secondary-6 font-14">
                Fecha de Finalización:
              </div>
              <div class="font-weight-normal color-black font-16">
                {{ finishDate | date }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-md-12 col-xl-3 text-right d-flex justify-content-center align-items-center"
        >
          <dropdown
            :id="`announcement-btn-${id}`"
            class="actions-dropdown"
            :items="actionItems"
            title=" Acciones "
          />
        </div>
      </div>
    </custom-callout>
    <div v-if="!isFinished" class="alert alert-warning">
      <i class="fas fa-bell-exclamation mr-2" />
      Al culminar la fecha de finalización podrá comenzar con el proceso de
      determinación de las propuestas de servicio.
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import Dropdown from 'dropdown';
import alertMixin from '@/mixins/alert.mixin.js';
import { assignEvaluatorToProposalsByAnnouncement } from '@/modules/serviceProposalHistory/api';
import { announcementStatuses } from '@/utils/constants/announcementStatus';

export default {
  name: 'AnnouncementRow',
  components: {
    CustomCallout,
    Dropdown,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
    },
    areaId: {
      type: Number,
    },
    statusId: {
      type: Number,
    },
    name: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
    publishDate: {
      type: String,
      default: '',
    },
    finishDate: {
      type: String,
      default: '',
    },
    isProposalDetermined: {
      type: Boolean,
      default: false,
    },
    hasSubmittedProposals: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isFinished() {
      return new Date(this.finishDate) - new Date() < 0;
    },
    showProposals() {
      return (
        this.isFinished ||
        this.userHasPermissions('proposal.process.finished.announcement')
      );
    },
    sufixType() {
      return this.name
        .toLowerCase()
        .replaceAll(' ', '-')
        .normalize('NFD')
        .replaceAll(/[\u0300-\u036f]/g, '');
    },
    actionItems() {
      return [
        {
          label: 'Generar Carta',
          icon: 'fas fa-file-alt text-green ',
          click: this.generateLetter,
          visible: this.userHasPermissions(
            'provider.competitionprocess.generateletter.view'
          ),
        },
        {
          label: 'Ver Propuestas',
          icon: 'fas fa-file-import text-green',
          visible: this.showProposals,
          click: this.emitView,
        },
        {
          label: 'Asignar Evaluadores',
          icon: 'fas fa-clone text-green pr-1',
          visible:
            this.userHasPermissions(
              'provider.announcement.evaluators.assign'
            ) &&
            this.hasSubmittedProposals &&
            this.statusId == announcementStatuses.Finalizado,
          click: this.asignEvaluators,
        },
      ];
    },
  },
  async mounted() {},
  methods: {
    emitView() {
      if (!this.showProposals) {
        return;
      }

      this.$emit('view', this.id, this.areaId);
    },
    generateLetter() {
      if (!this.isProposalDetermined) {
        this.ShowToast(
          'Error',
          'Se debe terminar el proceso de determinación de las propuestas.',
          'error'
        );

        return;
      }
      this.$router.push({
        name: 'GenerateLetter',
        params: { id: this.id },
      });
    },
    async asignEvaluators() {
      try {
        await assignEvaluatorToProposalsByAnnouncement(this.id);
        this.ShowToast(
          '',
          'Los evaluadores han sido asignados a las propuestas exitosamente',
          'success'
        );
        this.$emit('refresh', { page: 1 });
      } catch (error) {
        this.ShowToast('', error.response.data.message, 'error');
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/brand_variables.scss';

.badge-pill {
  padding: 10px 25px;
}

.badge-servicios-profesionales,
.badge-educacion-especial {
  color: #d44d28;
  background-color: #fed8bc;
}

.badge-oficina-mejoramiento-escuelas-publicas {
  color: #173597;
  background-color: #dce4fe;
  text-wrap: auto;
}

.badge-infraestructura {
  color: #173597;
  background-color: #dce4fe;
}

.badge-transportacion {
  color: #1e8c9a;
  background-color: #b4e9eb;
}

.badge-remedio-provisional {
  color: #9a3277;
  background-color: #fadcf1;
}

.badge-oficina-central-de-compras {
  color: #089b05;
  background-color: #d2efd1;
}

.button-disabled {
  color: #bababa;
  border-color: #bababa;
}

.button-disabled:hover {
  color: #bababa;
  background-color: #f7f7f7;
  cursor: default;
}
</style>
